import { render } from "./jin-fc3d.vue?vue&type=template&id=c601227e&scoped=true"
import script from "./jin-fc3d.vue?vue&type=script&lang=js"
export * from "./jin-fc3d.vue?vue&type=script&lang=js"

import "./jin-fc3d.vue?vue&type=style&index=0&id=c601227e&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c601227e"]])

export default __exports__